var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.14 110.06C215.14 52.0265 168.103 4.98081 110.08 4.98082C52.0567 4.98082 5.01952 52.0266 5.01953 110.06C5.01953 168.094 52.0567 215.14 110.08 215.14C168.103 215.14 215.14 168.094 215.14 110.06Z",
    stroke: "#1D1D1B",
    strokeWidth: 8.48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.08 176.933L110.08 43.1882",
    stroke: "#1D1D1B",
    strokeWidth: 8.48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7979 100.481L110.08 43.1883",
    stroke: "#1D1D1B",
    strokeWidth: 8.48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M167.399 100.481L110.08 43.1883",
    stroke: "#1D1D1B",
    strokeWidth: 8.48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendButton);
export default __webpack_public_path__ + "static/media/send_button.f844bb5955264a44b555d2f8e5f998ed.svg";
export { ForwardRef as ReactComponent };